import { z } from 'zod';
import { PHOTO_CONTENT_TYPES } from './property.js';
/** Brand settings: the agency name and the colour its public pages are built from. */
export const brandSchema = z
    .object({
    name: z.string().trim().min(2).max(80).optional(),
    colour: z
        .string()
        .regex(/^#[0-9a-fA-F]{6}$/, 'Use a colour like #0F766E')
        .optional(),
})
    .refine((value) => Object.keys(value).length > 0, 'Provide at least one field');
export const logoUploadSchema = z.object({ contentType: z.enum(PHOTO_CONTENT_TYPES) });
export const logoConfirmSchema = z.object({ key: z.string().min(10).max(300) });
//# sourceMappingURL=brand.js.map